import { resolveVendorDirectoryApiBase } from "./clientPortalFetch.js";

function authHeaders() {
  return { "Content-Type": "application/json" };
}

export async function listClaims(clientViewId, query = {}) {
  const params = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") params.set(key, value);
  });
  const response = await fetch(
    `${resolveVendorDirectoryApiBase(clientViewId)}/reclamaciones?${params}`,
    { credentials: "include", headers: authHeaders() }
  );
  const body = await response.json();
  if (!response.ok) throw new Error(body.error || "No se pudieron cargar las reclamaciones.");
  return body;
}

export async function getClaim(clientViewId, claimId) {
  const response = await fetch(
    `${resolveVendorDirectoryApiBase(clientViewId)}/reclamaciones/${claimId}`,
    { credentials: "include", headers: authHeaders() }
  );
  const body = await response.json();
  if (!response.ok) throw new Error(body.error || "No se pudo cargar la reclamación.");
  return body;
}

export async function assignClaim(clientViewId, claimId, payload) {
  const response = await fetch(
    `${resolveVendorDirectoryApiBase(clientViewId)}/reclamaciones/${claimId}/asignar`,
    {
      method: "POST",
      credentials: "include",
      headers: authHeaders(),
      body: JSON.stringify(payload),
    }
  );
  const body = await response.json();
  if (!response.ok) throw new Error(body.error || "No se pudo asignar la reclamación.");
  return body;
}

export async function requestClaimInformation(clientViewId, claimId, payload) {
  const response = await fetch(
    `${resolveVendorDirectoryApiBase(clientViewId)}/reclamaciones/${claimId}/solicitar-informacion`,
    {
      method: "POST",
      credentials: "include",
      headers: authHeaders(),
      body: JSON.stringify(payload),
    }
  );
  const body = await response.json();
  if (!response.ok) throw new Error(body.error || "No se pudo solicitar información.");
  return body;
}

export async function previewClaimDecision(clientViewId, claimId, payload) {
  const response = await fetch(
    `${resolveVendorDirectoryApiBase(clientViewId)}/reclamaciones/${claimId}/preview`,
    {
      method: "POST",
      credentials: "include",
      headers: authHeaders(),
      body: JSON.stringify(payload),
    }
  );
  const body = await response.json();
  if (!response.ok) throw new Error(body.error || "No se pudo generar la vista previa.");
  return body;
}

export async function approveClaim(clientViewId, claimId, payload) {
  const response = await fetch(
    `${resolveVendorDirectoryApiBase(clientViewId)}/reclamaciones/${claimId}/aprobar`,
    {
      method: "POST",
      credentials: "include",
      headers: authHeaders(),
      body: JSON.stringify(payload),
    }
  );
  const body = await response.json();
  if (!response.ok) throw new Error(body.error || "No se pudo aprobar la reclamación.");
  return body;
}

export async function rejectClaim(clientViewId, claimId, payload) {
  const response = await fetch(
    `${resolveVendorDirectoryApiBase(clientViewId)}/reclamaciones/${claimId}/rechazar`,
    {
      method: "POST",
      credentials: "include",
      headers: authHeaders(),
      body: JSON.stringify(payload),
    }
  );
  const body = await response.json();
  if (!response.ok) throw new Error(body.error || "No se pudo rechazar la reclamación.");
  return body;
}

export async function listSubmissions(clientViewId, query = {}) {
  const params = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") params.set(key, value);
  });
  const response = await fetch(
    `${resolveVendorDirectoryApiBase(clientViewId)}/envios?${params}`,
    { credentials: "include", headers: authHeaders() }
  );
  const body = await response.json();
  if (!response.ok) throw new Error(body.error || "No se pudieron cargar los envíos.");
  return body;
}
